/* eslint-disable jsx-a11y/label-has-associated-control */
import { alpha } from '@material-ui/core/styles';
import { Box, Grid, Paper, Radio, RadioGroup, CardActionArea, FormControlLabel, Card, Input } from '@material-ui/core';
import ColorFill from '@iconify/icons-eva/color-palette-fill';

// hooks
import { useState } from 'react';
import { Icon } from '@iconify/react';
import useSettings from '../../hooks/useSettings';

// ----------------------------------------------------------------------

export default function SettingColor() {
  const { themeColor, onChangeColor, colorOption, onChangeCustomColor } = useSettings();
  const [colorPicker, setColorPicker] = useState('#0000FF');
  // console.log('colorOption', colorOption);

  return (
    <>
      <RadioGroup name="themeColor" value={themeColor} onChange={onChangeColor}>
        <Grid container spacing={1.5} dir="ltr">
          {colorOption.map((color, index) => {
            const colorName = color.name;
            const colorValue = color.value;
            const isSelected = themeColor === colorName;

            return (
              <Grid item xs={4} key={colorName}>
                <Paper
                  variant={isSelected ? 'elevation' : 'outlined'}
                  sx={{
                    ...(isSelected && {
                      bgcolor: alpha(colorValue, 0.12),
                      border: `solid 2px ${colorValue}`,
                      boxShadow: `inset 0 4px 8px 0 ${alpha(colorValue, 0.24)}`
                    })
                  }}
                >
                  <CardActionArea sx={{ borderRadius: 1, color: colorValue }}>
                    <Box
                      sx={{
                        height: 48,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      <Box
                        sx={{
                          width: 24,
                          height: 14,
                          borderRadius: '50%',
                          bgcolor: colorValue,
                          transform: 'rotate(-45deg)',
                          transition: (theme) =>
                            theme.transitions.create('all', {
                              easing: theme.transitions.easing.easeInOut,
                              duration: theme.transitions.duration.shorter
                            }),
                          ...(isSelected && { transform: 'none' })
                        }}
                      />
                    </Box>

                    <FormControlLabel
                      label=""
                      value={colorName}
                      control={<Radio sx={{ display: 'none' }} />}
                      sx={{
                        top: 0,
                        margin: 0,
                        width: '100%',
                        height: '100%',
                        position: 'absolute'
                      }}
                    />
                  </CardActionArea>
                </Paper>
              </Grid>
            );
          })}
          {/* <FormControlLabel
          label=""
          value={colorPicker}
          control={<Radio sx={{ display: 'none' }} />}
          sx={{
            top: 0,
            margin: 0,
            width: '100%',
            height: '100%',
            position: 'absolute'
          }}
        /> */}
        </Grid>
      </RadioGroup>
      <Paper
        variant="outlined"
        sx={{
          ...{
            bgcolor: alpha(colorPicker, 0.12),
            border: `solid 2px ${colorPicker}`,
            boxShadow: `inset 0 4px 8px 0 ${alpha(colorPicker, 0.24)}`,
            width: '58px',
            height: 48,
            margin: '12px'
          }
        }}
      >
        {/* <input type="file" id="file" style={{ display: 'none' }} onChange={(e) => this.onChangeFile(e)} />
        <label htmlFor="file">
          <span className="fa fa-edit edit-icon"> </span>
        </label> */}
        <input
          type="color"
          // id="customcolor"
          value={colorPicker}
          onChange={onChangeColor}
          style={{
            // display: 'none',
            border: 'none',
            width: 28,
            height: 17,
            margin: '13px',
            borderRadius: '50%',
            bgcolor: colorPicker,
            transform: 'rotate(-45deg)',
            transition: (theme) =>
              theme.transitions.create('all', {
                easing: theme.transitions.easing.easeInOut,
                duration: theme.transitions.duration.shorter
              })
            // ...(isSelected && { transform: 'none' })
          }}
        />
        {/* <label htmlFor="customcolor"> */}
        {/* <Icon icon={ColorFill} height={40} width={35} /> */}
        {/* </label> */}
        {/* </Box> */}
      </Paper>
    </>
  );
}
